import React , { useState  } from 'react';
import { Redirect } from 'react-router-dom';
import jwt from 'jwt-decode';


export default function LoginModel  () {



   async function loginUser(email, password){

        try{
            const res = await fetch('http://143.198.24.1:3000/api/user/login', {
            method: 'POST',
            headers: {'Content-Type':'application/json' },
            body:JSON.stringify( {"email": email , "password": password })
        });
            const data = await res.json();
            const token = data.output;
            const user = jwt(token); // decode token here
            localStorage["role"] = user.role;
            localStorage["token"] = token;
            setDone(true);
            setModalClick("modal");
        } catch(err){
            console.error(err);
            setWrong(true);
            setModalClick("null");
        }
    }

    const [state, setState] =useState({email: undefined , password:undefined}) ;
    const [wrong, setWrong] =useState(false) ;
    const [done, setDone] =useState(false) ;
    const [modalClick , setModalClick] = useState("null");
    
    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
      setState(state => ( {...state, [name] : value} ));
    }

    const submitLogin = () => {
        loginUser(state.email , state.password);
      }

      if (done)
      {
          if(localStorage["role"] === "1" )
          {
            return(
                <Redirect to={"/userhome"} />
            ); 
          }
          else if (localStorage["role"] === "0")
          {
            return(
                <Redirect to={"/adminhome"} />
            ); 
          }
      }

    

    return(
        <div className="modal fade login-model" id="loginModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">تسجيل الدخول</h3>
                            <p className="model-subtitle">ابقى على إطلاع بآخر المقالات و العروض التى نقدمها</p>
                        </div>
                        <form>
                            <div className="form-group cassandra-form-group">
                                <label>البريد الإلكترونى</label>
                                <input  className="form-control cassandra-form-control" name="email" value={state.email} onChange={handleChange} autoComplete="username"  type="email" placeholder="البريد الالكتروني"/>
                            </div>
                            <div className="form-group cassandra-form-group">
                                <label>كلمة المرور</label>
                                <input  className="form-control cassandra-form-control"  name="password" value={state.password} onChange={handleChange} autoComplete="current-password" type="password" placeholder="كلمه المرور"/>
                                <div className="d-flex justify-content-end forget-password-container">
                                    <a className="forget-password-link" href='#passwordModel' data-dismiss="modal" data-toggle="modal" >نسيت كلمة المرور ؟</a>
                                </div>
                            </div>
                            <div className="text-center">
                            <button className="submit-btn" type="button"  data-dismiss={modalClick} onClick={submitLogin} > تسجيل الدخول </button>
                                {
                                    wrong && 
                                    <div className="wrong-data" >خطأ في البريد الالكتروني أو كلمة المرور </div>
                                }
                                <div className="remember-checkout">
                                <label><input type="checkbox"/>تذكرنى</label>
                                </div>
                                <a className="register-link" href='#registerModel' data-toggle="modal">تسجيل جديد؟</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
